/**
 * Global Privacy Control (GPC) — https://globalprivacycontrol.org/
 * A browser/extension-set signal that legally counts as an opt-out-of-sale/
 * sharing request under CPRA (California), Colorado, Connecticut, and other
 * US state privacy laws. Businesses covered by those laws must honor it
 * automatically, without requiring the user to click anything.
 */

/**
 * Whether the current browser is sending the GPC signal.
 * @returns {boolean}
 */
export function hasGPC() {
  return typeof navigator !== 'undefined' && navigator.globalPrivacyControl === true
}
